import { typeBuilder } from 'base/shared/TypeHelper';

export default typeBuilder([
  'REVIEWS_PENDING_REQUEST',
  'REVIEWS_PENDING_SUCCESS',
  'REVIEWS_PENDING_ERROR',
  'RESET_REVIEWS',
]);
